import { useQuery } from '@muse-web/router'

import { type TCreatorOfferContext } from '@core/session-dialogs'
import { useValues } from '@core/store'
import { authIntentStore } from '@features/auth'
import { CHECKOUT_PARAMS, checkoutStore } from '@features/checkout'
import { creatorProfileOfferStore, getHqStoragePaywallFlow } from '@features/paywall'

export const useCreatorOfferContext = (): TCreatorOfferContext => {
    const query = useQuery<Record<string, string | undefined>>()
    const [offer, regPaywall, isCheckoutRedirectPending] = useValues([
        creatorProfileOfferStore.getRoot,
        authIntentStore.props.getRegPaywall,
        checkoutStore.props.getIsRedirectPending,
    ])

    const hasCheckoutReturn =
        query[CHECKOUT_PARAMS.productId] !== undefined ||
        query[CHECKOUT_PARAMS.success] !== undefined

    return {
        isCandidate: offer.candidate,
        isChecking: offer.checking,
        isAssignmentSettled: offer.assignmentSettled,
        isBlocked:
            offer.welcomeLinkSeen ||
            hasCheckoutReturn ||
            Boolean(regPaywall) ||
            isCheckoutRedirectPending ||
            getHqStoragePaywallFlow() !== null,
    }
}
